module.exports = __webpack_public_path__ + "static/media/playertable icon-4.961f1143.svg";